module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "step-two"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("\n      7. Total " + _vm._s(_vm.createdObject.KPI) + " per week\n    ")]), _vm._v(" "), _c('HotTable', {
    ref: "salesTableId",
    attrs: {
      "root": _vm.salesTableId,
      "settings": _vm.weekSales
    }
  })], 1), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "checkbox"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.createdObject.base_sales_flag),
      expression: "createdObject.base_sales_flag"
    }],
    attrs: {
      "id": "Historic",
      "type": "checkbox"
    },
    domProps: {
      "checked": _vm.createdObject.base_sales_flag ? 'checked' : '',
      "checked": Array.isArray(_vm.createdObject.base_sales_flag) ? _vm._i(_vm.createdObject.base_sales_flag, null) > -1 : (_vm.createdObject.base_sales_flag)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.createdObject.base_sales_flag,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.createdObject, "base_sales_flag", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.createdObject, "base_sales_flag", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.createdObject, "base_sales_flag", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "Historic"
    }
  }, [_vm._v("Historic Sales Data")])])]), _vm._v(" "), _c('div', {
    class: {
      'invalid-field': (!_vm.validate['step2'])
    },
    attrs: {
      "id": _vm.checkValidate = _vm.validate['step2']
    }
  }, [_c('p', {
    staticClass: "error-msg"
  }, [_vm._v("Please add valid entry in above table.")])]), _vm._v(" "), _c('simplert', {
    ref: "simplert",
    attrs: {
      "useRadius": true,
      "useIcon": true
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-56c02b50"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Model-two.vue
// module id = 312
// module chunks = 1